<markdown
  [data]="data()"
  (ready)="onReady()"
/>
